import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import usePageMeta from "@/hooks/usePageMeta";

export default function ServicesIndex() {
  usePageMeta(
    "Services | Beauté Solutions — Peoria, AZ",
    "Beauté Solutions services — permanent cosmetics, laser esthetics and skin health in Peoria, AZ. Book a free consultation online."
  );
  return (
    <div className="grain bg-cream">
      <PageHero
        eyebrow="Services"
        lines={["A brand-new services", "experience is coming."]}
        lead="We're redesigning this section from the ground up. In the meantime, book a free consultation and Sherry will walk you through every option in person."
      />
      <section className="pb-24" data-testid="services-placeholder">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal className="flex flex-wrap gap-4">
            <a
              href="https://beautesolutions.intakeq.com/booking"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="services-placeholder-booking"
              className="group inline-flex items-center gap-2.5 rounded-full bg-gold text-espresso px-10 py-5 text-base font-semibold transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-golddark hover:text-white"
            >
              Book a free consultation
              <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <Link
              to="/about"
              data-testid="services-placeholder-about"
              className="inline-flex items-center gap-2 rounded-full border border-gold/60 text-golddark px-10 py-5 text-base font-semibold transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 hover:bg-gold hover:text-espresso"
            >
              Meet Sherry
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
